import { render, staticRenderFns } from "./benefitRemaining.vue?vue&type=template&id=66679d5e&scoped=true"
import script from "./benefitRemaining.vue?vue&type=script&lang=js"
export * from "./benefitRemaining.vue?vue&type=script&lang=js"
import style0 from "./benefitRemaining.vue?vue&type=style&index=0&id=66679d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66679d5e",
  null
  
)

export default component.exports